"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _refType = _interopRequireDefault(require("@mui/utils/refType"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _rootShouldForwardProp = _interopRequireDefault(require("../styles/rootShouldForwardProp"));
var _zeroStyled = require("../zero-styled");
var _useControlled = _interopRequireDefault(require("../utils/useControlled"));
var _useFormControl = _interopRequireDefault(require("../FormControl/useFormControl"));
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _switchBaseClasses = require("./switchBaseClasses");
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, checked = ownerState.checked, disabled = ownerState.disabled, edge = ownerState.edge;
    var slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && "edge".concat((0, _capitalize.default)(edge))
        ],
        input: [
            'input'
        ]
    };
    return (0, _composeClasses.default)(slots, _switchBaseClasses.getSwitchBaseUtilityClass, classes);
};
var SwitchBaseRoot = (0, _zeroStyled.styled)(_ButtonBase.default)({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: function(param) {
                var edge = param.edge, ownerState = param.ownerState;
                return edge === 'start' && ownerState.size !== 'small';
            },
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: function(param) {
                var edge = param.edge, ownerState = param.ownerState;
                return edge === 'end' && ownerState.size !== 'small';
            },
            style: {
                marginRight: -12
            }
        }
    ]
});
var SwitchBaseInput = (0, _zeroStyled.styled)('input', {
    shouldForwardProp: _rootShouldForwardProp.default
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ var SwitchBase = /*#__PURE__*/ React.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, defaultChecked = props.defaultChecked, disabledProp = props.disabled, _props_disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _props_disableFocusRipple === void 0 ? false : _props_disableFocusRipple, _props_edge = props.edge, edge = _props_edge === void 0 ? false : _props_edge, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, _props_required = props.required, required = _props_required === void 0 ? false : _props_required, tabIndex = props.tabIndex, type = props.type, value = props.value, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, other = _object_without_properties(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "defaultChecked",
        "disabled",
        "disableFocusRipple",
        "edge",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value",
        "slots",
        "slotProps"
    ]);
    var _ref = _sliced_to_array((0, _useControlled.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    }), 2), checked = _ref[0], setCheckedState = _ref[1];
    var muiFormControl = (0, _useFormControl.default)();
    var handleFocus = function(event) {
        if (onFocus) {
            onFocus(event);
        }
        if (muiFormControl && muiFormControl.onFocus) {
            muiFormControl.onFocus(event);
        }
    };
    var handleBlur = function(event) {
        if (onBlur) {
            onBlur(event);
        }
        if (muiFormControl && muiFormControl.onBlur) {
            muiFormControl.onBlur(event);
        }
    };
    var handleInputChange = function(event) {
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) {
            return;
        }
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) {
            // TODO v6: remove the second argument.
            onChange(event, newChecked);
        }
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') {
            disabled = muiFormControl.disabled;
        }
    }
    var hasLabelFor = type === 'checkbox' || type === 'radio';
    var ownerState = _object_spread_props(_object_spread({}, props), {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({
            input: inputProps
        }, slotProps)
    };
    var _ref1 = _sliced_to_array((0, _useSlot.default)('root', {
        ref: ref,
        elementType: SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: _object_spread(_object_spread_props(_object_spread({}, externalForwardedProps), {
            component: 'span'
        }), other),
        getSlotProps: function(handlers) {
            return _object_spread_props(_object_spread({}, handlers), {
                onFocus: function(event) {
                    var _handlers_onFocus;
                    (_handlers_onFocus = handlers.onFocus) === null || _handlers_onFocus === void 0 ? void 0 : _handlers_onFocus.call(handlers, event);
                    handleFocus(event);
                },
                onBlur: function(event) {
                    var _handlers_onBlur;
                    (_handlers_onBlur = handlers.onBlur) === null || _handlers_onBlur === void 0 ? void 0 : _handlers_onBlur.call(handlers, event);
                    handleBlur(event);
                }
            });
        },
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    }), 2), RootSlot = _ref1[0], rootSlotProps = _ref1[1];
    var _ref2 = _sliced_to_array((0, _useSlot.default)('input', {
        ref: inputRef,
        elementType: SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: function(handlers) {
            return {
                onChange: function(event) {
                    var _handlers_onChange;
                    (_handlers_onChange = handlers.onChange) === null || _handlers_onChange === void 0 ? void 0 : _handlers_onChange.call(handlers, event);
                    handleInputChange(event);
                }
            };
        },
        ownerState: ownerState,
        additionalProps: _object_spread({
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type
        }, type === 'checkbox' && value === undefined ? {} : {
            value: value
        })
    }), 2), InputSlot = _ref2[0], inputSlotProps = _ref2[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({}, rootSlotProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputSlot, _object_spread({}, inputSlotProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: _propTypes.default.bool,
    /**
   * If `true`, the component is checked.
   */ checked: _propTypes.default.bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: _propTypes.default.node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * @ignore
   */ defaultChecked: _propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: _propTypes.default.bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: _propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: _propTypes.default.node.isRequired,
    /**
   * The id of the `input` element.
   */ id: _propTypes.default.string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: _propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: _refType.default,
    /*
   * @ignore
   */ name: _propTypes.default.string,
    /**
   * @ignore
   */ onBlur: _propTypes.default.func,
    /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: _propTypes.default.func,
    /**
   * @ignore
   */ onFocus: _propTypes.default.func,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: _propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   */ required: _propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        input: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        input: _propTypes.default.elementType,
        root: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.object,
    /**
   * @ignore
   */ tabIndex: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]),
    /**
   * The input component prop `type`.
   */ type: _propTypes.default.string.isRequired,
    /**
   * The value of the component.
   */ value: _propTypes.default.any
} : void 0;
var _default = exports.default = SwitchBase;
